import { useNavigate } from "react-router";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/reduxDispatch";
import PlaceholderCard from "../component/placeholder";
import { useEffect, useState } from "react";
import ChatBotName from "../component/chatBotDetails";
import { apiFetchSingleBot } from "../../../../services/apiCalls/user/chatbot";
import colors from "../../../../theme/color";

const ChatBotList = () => {
  const { userProfile } = useAppSelector((s) => s.userProfile);
  const [newBotDetails, setNewBotDetails] = useState(false);
  const [status, setStatus] = useState("idle");
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const processSingleClickedBot = (id) => {
    setStatus("loading");
    dispatch(apiFetchSingleBot(id, setStatus));
  };

  useEffect(() => {
    if (status === "success") {
      setStatus("idle");
      navigate("/user/dashboard/bot/editBot");
    }
  }, [status]);

  return (
    <div className="relative">
      <div className="px-4 sm:px-8 md:px-20 lg:px-56 relative h-screen z-50">
        {/* < /> */}

        {userProfile.bots.length > 0 ? (
          <>
            <div className="flex py-10">
              <div
                // onClick={() => navigate("/user/dashboard/bot/createNew")}
                onClick={() => setOpen(true)}
                className="text-white p-2 bg-black rounded-xl px-6 font-semibold cursor-pointer"
              >
                New AI bot
              </div>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {userProfile.bots.map((bot, index) => {
                return (
                  <div
                    key={index}
                    onClick={() => processSingleClickedBot(bot._id)}
                  >
                    <PlaceholderCard
                      key={bot._id}
                      _id={bot._id}
                      botName={bot.botName}
                      botPicture={bot.botPicture}
                    />
                  </div>
                );
              })}
            </div>{" "}
          </>
        ) : (
          <div className="flex justify-center my-10">
            <div
              // onClick={() => navigate("/user/dashboard/bot/createNew")}
              onClick={() => setOpen(true)}
              className="text-white p-2 bg-black rounded-xl px-6 font-semibold cursor-pointer"
            >
              Create first AI Chatbot
            </div>
          </div>
        )}
        {open && (
          <div
            className="absolute inset-0 -mt-32"
            // style={{ backgroundColor: colors.black }}
          >
            <ChatBotName setOpen={setOpen} open={open} />
          </div>
        )}
      </div>
      {/* <div> */}
      {status === "loading" && (
        <div
          className="absolute inset-0 z-50 justify-center flex items-center -mt-40"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
        >
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
};

export default ChatBotList;
